import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { CmsStructureModel, OccCmsPageAdapter, PageContext, PageType, SiteContextParamsService } from '@spartacus/core';

import { CustomOccCmsPageRequest, CustomPageContext } from '../../models';
import { CUSTOM_BRAND } from '../../constants';
import { PdpTypeEnum } from '../../enums';

@Injectable({
  providedIn: 'root'
})
export class CustomOccCmsPageAdapter extends OccCmsPageAdapter {
  private readonly paramsService = inject(SiteContextParamsService);

  override load(pageContext: PageContext): Observable<CmsStructureModel> {
    return super.load({
      ...pageContext,
      id: this.cleanPageLabel(pageContext.id) || '/'
    });
  }

  override getPagesRequestParams(context: CustomPageContext): CustomOccCmsPageRequest {
    const httpParams = super.getPagesRequestParams(context) as CustomOccCmsPageRequest;

    httpParams.fields = 'FULL';

    if (context.customPageType && context.customPageType !== PdpTypeEnum.PRODUCT) {
      if (context.customPageType === PageType.RECIPE_CATEGORY_PAGE as PageType) {
        httpParams.pageLabelOrId = null;
        httpParams.code = context.id;
        httpParams.pageType = PageType.RECIPE_CATEGORY_PAGE as PageType;
      } else {
        httpParams.cspType = context.customPageType;
      }
    }

    return httpParams;
  }

  private cleanPageLabel(pageLabel: string): string {
    // TODO-EL: use native spartacus helpers
    const brands = this.paramsService.getParamValues(CUSTOM_BRAND);
    const brand = brands?.find((brandRoute) => pageLabel.startsWith(`/${brandRoute}/`));
    return brand ? pageLabel.slice(brand.length + 1) : pageLabel;
  }
}
